var ImportConfigs = function() {
	
}

module.exports = ImportConfigs;